import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';

import * as UserActions from '../actions/user.actions';
import { AuthenticationService } from '../../service/authentification.service';
import { UserActionsUnions, UserActionTypes } from '../actions/user.actions';
import { UserService } from '../../service/user.service';
import { environment } from '../../../../../environments/environment';

@Injectable()
export class UserEffects {

    constructor(
        private actions: Actions<UserActionsUnions>,
        private _authentificationService: AuthenticationService,
        private _router: Router,
        private _userService: UserService
    ) { }

    GetUser = createEffect(() =>
        this.actions.pipe(
            ofType(UserActionTypes.GET_USER),
            exhaustMap(() => {
                return this._authentificationService.me().pipe(
                    map((authResponse) => {
                        return UserActions.GetUserSuccess(authResponse);
                    }),
                    catchError(() => of(UserActions.GetUserFailure()))
                );
            }),
            catchError(() => of(UserActions.GetUserFailure()))
        )
    );

    resetPassword = createEffect(() => this.actions.pipe(
        ofType(UserActions.ResetPassword),
        exhaustMap((action) => {
            return this._authentificationService.newPassword(action.email, environment.urls.url).pipe(
                map(() => {
                    return UserActions.ResetPasswordSuccess({ message: 'auth.reset_password.success' });
                }),
                catchError(() => of(UserActions.ResetPasswordFailure({ message: 'auth.reset_password.error' })))
            )
        })
    ));

    resetPasswordConfirm = createEffect(() => this.actions.pipe(
        ofType(UserActions.ResetPasswordConfirm),
        exhaustMap((action) => {
            return this._authentificationService.sendNewPassword(action.uid, action.token, action.password, action.password).pipe(
                map(() => {
                    this._router.navigate(['/login'])
                    return UserActions.ResetPasswordConfirmSuccess({ message: 'auth.reset_password_confirm.success' });
                }),
                catchError(() => of(UserActions.ResetPasswordConfirmFailure({ message: 'auth.reset_password_confirm.error' })))
            )
        })
    ));
}

